import { create } from 'zustand'
import { CheckInDateType, PlanType } from '../components/landing-page/availability-tab/type'

interface PlanStore {
  isShowCheckInDateAlert: boolean
  setIsShowCheckInDateAlert: (isShowCheckInDateAlert: boolean) => void

  selectedPlan: PlanType | null
  setSelectedPlan: (plan: PlanType | null) => void

  selectedCheckInDate: CheckInDateType | null
  setSelectedCheckInDate: (checkInDate: CheckInDateType | null) => void

  validationErrors: {
    childBirthdate: boolean
  }
  setValidationErrors: (errors: any) => void
  openModalFilter: boolean
  setOpenModalFilter: (openModalFilter: boolean) => void
}

export const usePlanStore = create<PlanStore>()((set) => ({
  isShowCheckInDateAlert: false,
  setIsShowCheckInDateAlert: (value: boolean) => set((state) => ({ isShowCheckInDateAlert: value })),

  selectedPlan: null,
  setSelectedPlan: (plan: PlanType | null) => set((state) => ({ selectedPlan: plan })),

  selectedCheckInDate: null,
  setSelectedCheckInDate: (checkInDate: CheckInDateType | null) => set((state) => ({ selectedCheckInDate: checkInDate })),

  validationErrors: {
    childBirthdate: false,
  },
  setValidationErrors: (errors: any) => set((state) => ({ validationErrors: errors })),
  openModalFilter: false,
  setOpenModalFilter: (value: boolean) => set((state) => ({ openModalFilter: value })),
}))
